import { Checkbox as MuiCheckbox, FormControlLabel, FormControl, FormGroup } from '@mui/material';
import { withStyles } from '@mui/styles';

const styles = () => ({
    checkboxLabel: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
    },
});

const CheckboxList = ({ classes, field, options, render }) => {
    const renderLabel = (item) => {
        const value = typeof item === 'object' ? item.label : item;
        if (render) return render(value);
        return value;
    };

    return (
        <FormControl component="fieldset">
            <FormGroup>
                {options?.map((item) => (
                    <FormControlLabel
                        key={typeof item === 'object' ? item.value : item}
                        control={
                            <MuiCheckbox
                                checked={field.value.includes(
                                    typeof item === 'object' ? item.value : item
                                )}
                                {...field}
                                onChange={(e) =>
                                    field.onChange(
                                        e.target.checked
                                            ? [
                                                  ...field.value,
                                                  typeof item === 'object' ? item.value : item,
                                              ]
                                            : field.value.filter(
                                                  (s) =>
                                                      s !==
                                                      (typeof item === 'object' ? item.value : item)
                                              )
                                    )
                                }
                                value={typeof item === 'object' ? item.value : item}
                                color="primary"
                            />
                        }
                        classes={{ label: classes.checkboxLabel }}
                        label={renderLabel(item)}
                    />
                ))}
            </FormGroup>
        </FormControl>
    );
};

export default withStyles(styles)(CheckboxList);
